import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueLodash from 'vue-lodash'
import includes from 'lodash/includes'

import '@/assets/scss/style.scss'

Vue.config.productionTip = false

Vue.use(VueLodash, { name: 'custom', lodash: { includes } })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
